import { useBloc as useBlocNext } from "@blac/react";
import type { FC } from "react";
import React, { useState } from "react";
import { parseAssumedTokens } from "src/state/AssumedIdentityCubit/AssumedIdentityCubit";
import AuthenticationBloc from "src/state/UserCubit/AuthenticationBloc";
import {
  DebugButton,
  DebugFormGroup,
  DebugInfoBox,
  DebugKeyValue
} from "./debug.styles";

const DebugAssumeIdentity: FC = () => {
  const [, { assumeIdentity }] = useBlocNext(AuthenticationBloc);
  const [accessToken, setAccessToken] = useState("");
  const [refreshToken, setRefreshToken] = useState("");

  const bothTokensPasted = Boolean(accessToken.trim() && refreshToken.trim());
  const parsed = bothTokensPasted
    ? parseAssumedTokens({ accessToken, refreshToken })
    : undefined;
  const identity = parsed?.ok ? parsed.identity : undefined;
  const parseError = parsed && !parsed.ok ? parsed.reason : undefined;

  const handleAssume = () => {
    if (!identity) {
      return;
    }
    void assumeIdentity(
      {
        accessToken: accessToken.trim(),
        refreshToken: refreshToken.trim()
      },
      identity
    );
  };

  return (
    <div>
      <DebugInfoBox variant="warning">
        <p>
          Replaces the current session with the pasted member tokens and
          reloads. Writes are blocked until you enable write mode in the status
          bar.
        </p>
      </DebugInfoBox>
      <DebugFormGroup>
        <label htmlFor="assume-identity-access-token">Access token</label>
        <textarea
          id="assume-identity-access-token"
          value={accessToken}
          onChange={(e) => setAccessToken(e.target.value)}
          spellCheck={false}
        />
      </DebugFormGroup>
      <DebugFormGroup>
        <label htmlFor="assume-identity-refresh-token">Refresh token</label>
        <textarea
          id="assume-identity-refresh-token"
          value={refreshToken}
          onChange={(e) => setRefreshToken(e.target.value)}
          spellCheck={false}
        />
      </DebugFormGroup>
      {identity && (
        <>
          <DebugKeyValue>
            <span className="key">User ID</span>
            <span className="value mono">{identity.userId}</span>
          </DebugKeyValue>
          <DebugKeyValue>
            <span className="key">Access token expires</span>
            <span className="value">
              {new Date(identity.expiresAt).toLocaleString()}
            </span>
          </DebugKeyValue>
        </>
      )}
      {parseError && (
        <DebugInfoBox variant="warning">{parseError}</DebugInfoBox>
      )}
      <DebugButton
        className="danger"
        disabled={!identity}
        onClick={handleAssume}
      >
        Assume identity (read-only)
      </DebugButton>
    </div>
  );
};

export default DebugAssumeIdentity;
